import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RendezvenySzerkeszto from './RendezvenySzerkeszto';
import { belepesiListaLetoltese } from '../../belepesiLista';

// "2026-10-18 12:30:00" -> "2026. 10. 18. 12:30"
function datumSzoveg(s) {
    if (!s) {
        return '–';
    }
    const m = /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)/.exec(s);
    return m ? m[1] + '. ' + m[2] + '. ' + m[3] + '. ' + m[4] + ':' + m[5] : s;
}

// Rendezvények (minden admin): először csak a rendezvénycsoportok; egy csoportra kattintva megjelenik
// a csoport összes rendezvénye. A "Lássam" jelölés azt jelenti, hogy az admin a látogatói listában
// akkor is látni akarja a rendezvényt, ha a meghirdetése még nem kezdődött el.
// Az auditor mindent lát, de csak olvas: nincs "Új rendezvény" és "Másolás", a "Szerkesztés" helyett "Megtekintés" van
// (ugyanaz a panel, Mentés nélkül, a mezők inaktívak); a "Lássam" jelölés neki is működik.
export default function RendezvenyekOldal({ callAPI, felhasznalo }) {
    const csakOlvas = !(felhasznalo && felhasznalo.admin);
    const [csoportok, setCsoportok] = useState(undefined);
    const [nyitottID, setNyitottID] = useState(undefined);
    const [rendezvenyek, setRendezvenyek] = useState(undefined);   // a nyitott csoporté; undefined = töltődik
    const [szerkesztes, setSzerkesztes] = useState(undefined);     // {rendezvenyID?, csoportID} a nyitott szerkesztő panelhez
    const [masolasra, setMasolasra] = useState(undefined);         // a másolásra váró rendezvény (megerősítő kérdéshez)
    const [uzenet, setUzenet] = useState(undefined);
    const [listaKeszul, setListaKeszul] = useState(undefined);      // annak a rendezvénynek az azonosítója, aminek a belépési listája épp készül
    const nyitottRef = useRef(undefined);                          // a legutóbb nyitott csoport (a lassú válaszok eldobásához)

    function csoportokBetoltese() {
        callAPI('General.listRendezvenycsoportok', {}, function (resp) {
            setCsoportok(resp.data.csoportok);
        });
    }

    function rendezvenyekBetoltese(csoportID) {
        callAPI('General.listRendezvenyek', { csoportID: csoportID }, function (resp) {
            if (nyitottRef.current === csoportID) {   // közben másik csoportot nyithattak
                setRendezvenyek(resp.data.rendezvenyek);
            }
        });
    }

    useEffect(() => {
        csoportokBetoltese();
    }, []);

    function csoportNyitas(csoportID) {
        nyitottRef.current = csoportID;
        setNyitottID(csoportID);
        setRendezvenyek(undefined);
        setUzenet(undefined);
        rendezvenyekBetoltese(csoportID);
    }

    function onClick_csoport(csoport) {
        if (nyitottID === csoport.Id) {
            nyitottRef.current = undefined;
            setNyitottID(undefined);
            return;
        }
        csoportNyitas(csoport.Id);
    }

    function onChange_lassam(rendezveny, lassam) {
        // azonnal átbillentjük, hiba esetén visszaállítjuk
        function beallit(ertek) {
            setRendezvenyek(function (lista) {
                return lista === undefined ? lista : lista.map(function (r) {
                    return r.Id === rendezveny.Id ? Object.assign({}, r, { Lassam: ertek }) : r;
                });
            });
        }
        beallit(lassam);
        callAPI('General.saveRendezvenyLassam', { rendezvenyID: rendezveny.Id, lassam: lassam }, function (resp) {
            beallit(resp.data.rendezveny.Lassam);
        }, function () {
            beallit(!lassam);
        });
    }

    function onMentve(rendezveny) {
        // a csoport lehetett más is (áthelyezés), ezért a listát és a darabszámokat újratöltjük
        setSzerkesztes(undefined);
        csoportokBetoltese();
        csoportNyitas(rendezveny.Rendezvenycsoportid);
        setUzenet('Mentve: ' + rendezveny.Cim);
    }

    function onClick_belepesiLista(rendezveny) {
        setListaKeszul(rendezveny.Id);
        belepesiListaLetoltese(callAPI, rendezveny.Id, function () { setListaKeszul(undefined); });
    }

    function onClick_masolas_megerosites() {
        const forras = masolasra;
        setMasolasra(undefined);
        callAPI('General.copyRendezveny', { rendezvenyID: forras.Id }, function (resp) {
            csoportokBetoltese();
            rendezvenyekBetoltese(nyitottRef.current);
            setUzenet('Másolat elkészült: ' + resp.data.rendezveny.Cim + ' (még nincs meghirdetve)');
        });
    }

    if (csoportok === undefined) {
        return <div className="rendezvenyekOldal" />;
    }

    return (
        <div className="rendezvenyekOldal">
            {csoportok.length === 0 ? <div className="adminUres">Nincs rendezvénycsoport.</div> : undefined}
            {uzenet !== undefined ? <div className="rendezvenyUzenet">{uzenet}</div> : undefined}
            {csoportok.map(function (cs) {
                const nyitott = nyitottID === cs.Id;
                return (
                    <div key={cs.Id} className={'csoportKartya' + (nyitott ? ' nyitott' : '')}>
                        <div className="csoportFejlec">
                            <button type="button" className="csoportNyito" aria-expanded={nyitott} onClick={function () { onClick_csoport(cs); }}>
                                <FontAwesomeIcon icon={nyitott ? 'fa-chevron-down' : 'fa-chevron-right'} />
                                <span className="csoportCim">{cs.Cim}</span>
                            </button>
                            {csakOlvas ? undefined :
                                <Button variant="outline-primary" size="sm" onClick={function () { setSzerkesztes({ csoportID: cs.Id }); }}>
                                    <FontAwesomeIcon icon="fa-plus" /> Új rendezvény
                                </Button>
                            }
                            <span className="csoportDarab">{cs.Darab} rendezvény</span>
                        </div>
                        {nyitott ?
                            <div className="csoportTartalom">
                                {rendezvenyek === undefined ? <div className="adminUres">Betöltés…</div> : undefined}
                                {rendezvenyek !== undefined && rendezvenyek.length === 0 ? <div className="adminUres">Ebben a csoportban nincs rendezvény.</div> : undefined}
                                {rendezvenyek !== undefined && rendezvenyek.length > 0 ?
                                    <div className="tablaGorgeto">
                                        <table className="rendezvenyTabla">
                                            <thead>
                                                <tr>
                                                    <th>Lássam</th>
                                                    <th>Cím</th>
                                                    <th>Kezdete</th>
                                                    <th>Vége</th>
                                                    <th className="szam">Max. férőhely</th>
                                                    <th>Meghirdetés kezdete</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rendezvenyek.map(function (r) {
                                                    return (
                                                        <tr key={r.Id}>
                                                            <td className="lassam">
                                                                <input
                                                                    type="checkbox"
                                                                    aria-label={'Lássam: ' + r.Cim}
                                                                    checked={r.Lassam}
                                                                    onChange={function (e) { onChange_lassam(r, e.target.checked); }} />
                                                            </td>
                                                            <td className="cim">{r.Cim}</td>
                                                            <td>{datumSzoveg(r.Datumidokezdet)}</td>
                                                            <td>{datumSzoveg(r.Datumidoveg)}</td>
                                                            <td className="szam">{r.Maxferohely === null ? '–' : r.Maxferohely}</td>
                                                            <td className={r.Nyilvanos ? 'nyilvanos' : 'nemNyilvanos'}>
                                                                {r.Meghirdeteskezdete === null ? 'azonnal' : datumSzoveg(r.Meghirdeteskezdete)}
                                                                {r.Nyilvanos ? undefined : <span className="nemNyilvanosJelzo"> (még nem nyilvános)</span>}
                                                            </td>
                                                            <td className="muveletek">
                                                                <Button variant="outline-secondary" size="sm" disabled={listaKeszul !== undefined} title="A rendezvényre érkezők neve és belépőkódja, PDF-ben (előbb kód, majd név szerint)" onClick={function () { onClick_belepesiLista(r); }}>
                                                                    <FontAwesomeIcon icon="fa-file-pdf" /> {listaKeszul === r.Id ? 'Készül…' : 'Belépési lista'}
                                                                </Button>
                                                                {csakOlvas ? undefined :
                                                                    <Button variant="outline-secondary" size="sm" onClick={function () { setMasolasra(r); }}>
                                                                        <FontAwesomeIcon icon="fa-copy" /> Másolás
                                                                    </Button>
                                                                }
                                                                <Button variant="outline-primary" size="sm" onClick={function () { setSzerkesztes({ rendezvenyID: r.Id, csoportID: cs.Id }); }}>
                                                                    {csakOlvas ? <><FontAwesomeIcon icon="fa-eye" /> Megtekintés</> : <><FontAwesomeIcon icon="fa-pen" /> Szerkesztés</>}
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    : undefined
                                }
                            </div>
                            : undefined
                        }
                    </div>
                );
            })}

            {szerkesztes !== undefined ?
                <RendezvenySzerkeszto
                    rendezvenyID={szerkesztes.rendezvenyID}
                    csoportID={szerkesztes.csoportID}
                    csoportok={csoportok}
                    csakOlvas={csakOlvas}
                    callAPI={callAPI}
                    onHide={function () { setSzerkesztes(undefined); }}
                    onMentve={onMentve} />
                : undefined
            }

            <Modal show={masolasra !== undefined} onHide={function () { setMasolasra(undefined); }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Rendezvény másolása</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {masolasra !== undefined ?
                        <>
                            <p>Biztosan lemásolod ezt a rendezvényt?</p>
                            <p><b>{masolasra.Cim}</b></p>
                            <p className="masolasMegjegyzes">A másolat címe a „(másolat)” végződést kapja, a jegytípusok is másolódnak, a meghirdetése pedig nem kezdődik el, amíg át nem állítod.</p>
                        </>
                        : undefined
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={function () { setMasolasra(undefined); }}>Mégsem</Button>
                    <Button variant="primary" onClick={onClick_masolas_megerosites}>Másolás</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
